import React, { memo } from 'react';
import type { Rail } from 'react-compound-slider';
import styles from '../styles';

type Props = {
  getRailProps: Rail['getRailProps'];
  disabled: boolean;
};

const SliderRail = ({ getRailProps, disabled }: Props) => (
  <div
    data-testid="slider-rail"
    className={styles.rails}
    {...(disabled ? undefined : getRailProps())}
  />
);

export default memo(SliderRail);
